import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_DOCUMENTATION, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_DOCUMENTATION.STATE.LOT_DOCUMENTATION]: null,
  [LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION]: null,
  [LOT_DOCUMENTATION.STATE.DOCUMENT_SIGNERS_INFO]: null,
  [LOT_DOCUMENTATION.STATE.TRADE_DOCUMENT_TYPES]: null
}

const actions = {
  async [LOT_DOCUMENTATION.ACTIONS.GET_LOT_DOCUMENTATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/lotDocumentation?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_DOCUMENTATION.MUTATIONS.GET_LOT_DOCUMENTATION, resp.data)
  },
  async [LOT_DOCUMENTATION.ACTIONS.GET_TRADE_PROCESS_DOCUMENTATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_PROCESS_DOCUMENTATION, resp.data)
  },
  async [LOT_DOCUMENTATION.ACTIONS.GET_TRADE_PROCESS_DOCUMENTATION_SIGNERS] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation/${model.documentType}/signers?timestamp=${new Date().getTime()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_PROCESS_DOCUMENTATION_SIGNERS, resp.data)
  },
  async [LOT_DOCUMENTATION.ACTIONS.GET_TRADE_DOCUMENT_TYPES] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation/documentTypes?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_DOCUMENT_TYPES, resp.data)
  },
  async [LOT_DOCUMENTATION.ACTIONS.DELETE_TRADE_PROCESS_DOCUMENTATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation/${model.documentType}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_DOCUMENTATION.ACTIONS.ADD_TRADE_PROCESS_DOCUMENT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeProcessDocumentation`,
      model: model.file
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_DOCUMENTATION.ACTIONS.CLEAR_LOT_DOCUMENTATION] ({ commit }) {
    commit(LOT_DOCUMENTATION.MUTATIONS.CLEAR_LOT_DOCUMENTATION)
  },
  async [LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION] ({ commit }) {
    commit(LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION)
  },
  async [LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION_SIGNERS] ({ commit }) {
    commit(LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION_SIGNERS)
  },
  async [LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_DOCUMENT_TYPES] ({ commit }) {
    commit(LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_DOCUMENT_TYPES)
  }
}

const mutations = {
  [LOT_DOCUMENTATION.MUTATIONS.GET_LOT_DOCUMENTATION] (state, docs) {
    state[LOT_DOCUMENTATION.STATE.LOT_DOCUMENTATION] = docs
  },
  [LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_PROCESS_DOCUMENTATION] (state, docs) {
    state[LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION] = docs
  },
  [LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_PROCESS_DOCUMENTATION_SIGNERS] (state, model) {
    state[LOT_DOCUMENTATION.STATE.DOCUMENT_SIGNERS_INFO] = model
  },
  [LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION_SIGNERS] (state) {
    state[LOT_DOCUMENTATION.STATE.DOCUMENT_SIGNERS_INFO] = null
  },
  [LOT_DOCUMENTATION.MUTATIONS.GET_TRADE_DOCUMENT_TYPES] (state, docTypes) {
    state[LOT_DOCUMENTATION.STATE.TRADE_DOCUMENT_TYPES] = docTypes
  },
  [LOT_DOCUMENTATION.MUTATIONS.CLEAR_LOT_DOCUMENTATION] (state) {
    state[LOT_DOCUMENTATION.STATE.LOT_DOCUMENTATION] = null
  },
  [LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION] (state) {
    state[LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION] = null
  },
  [LOT_DOCUMENTATION.MUTATIONS.CLEAR_TRADE_DOCUMENT_TYPES] (state, docTypes) {
    state[LOT_DOCUMENTATION.STATE.TRADE_DOCUMENT_TYPES] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
